import React, { useEffect, useState } from "react";
import { X, Gift, Sparkles, Check } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VipPopup = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    if (sessionStorage.getItem("sp_vip_seen")) return;
    const t = setTimeout(() => setOpen(true), 3500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem("sp_vip_seen", "1");
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setDone(true);
    try {
      await axios.post(`${API}/vip-signup`, { email });
    } catch (err) {
      /* non-blocking */
    }
    toast({ title: "VIP Offer Claimed!", description: "Your complimentary champagne coupon is on its way." });
    setTimeout(close, 1600);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={close} />
      <div className="relative w-full max-w-md rounded-2xl border border-[var(--gold)]/30 bg-[#0e1a24] p-8 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.9)] animate-[floaty_6s_ease-in-out_infinite]">
        <button onClick={close} className="absolute right-4 top-4 text-gray-400 hover:text-[var(--gold)] transition-colors">
          <X size={22} />
        </button>
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[var(--gold)]/10 border border-[var(--gold)]/40">
            <Gift className="text-[var(--gold)]" size={30} />
          </div>
        </div>
        <h3 className="mt-5 text-center font-display text-2xl font-extrabold text-white">
          A Toast to Luxury
        </h3>
        <p className="mt-1 text-center text-sm font-semibold text-gold-gradient inline-flex items-center gap-1.5 w-full justify-center">
          <Sparkles size={15} /> VIP Welcome Offer <Sparkles size={15} />
        </p>
        <p className="mt-4 text-center text-sm text-gray-300 leading-relaxed">
          Book your first ride with Shadow Path and receive a complimentary champagne coupon to redeem with your booking.
        </p>
        {!done ? (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full rounded-full bg-white/5 border border-white/15 px-5 py-3 text-sm text-white placeholder:text-gray-500 focus:border-[var(--gold)] focus:outline-none transition-colors"
            />
            <button type="submit" className="btn-gold w-full rounded-full py-3 text-sm font-semibold uppercase tracking-widest">
              Claim My VIP Gift
            </button>
          </form>
        ) : (
          <div className="mt-6 flex items-center justify-center gap-2 rounded-full bg-[var(--gold)]/10 py-3 text-sm font-semibold text-[var(--gold)]">
            <Check size={18} /> You're on the list!
          </div>
        )}
      </div>
    </div>
  );
};

export default VipPopup;
